export default function Resources() {
  return (
    <div style={{ padding: '40px', textAlign: 'center' }}>
      <h1>Resources</h1>
      <p>This is the Resources page. Add helpful links and downloads.</p>
    </div>
  );
}
